import { Avatar } from "@mui/material";
import React from "react";
import { StandadCard } from "../../../../components/Cards";
import { CustomDatePicker } from "../../../../components/formsComponents/CustomPicker";
import { DateFilterDropdown } from "../../../Table/components/DateFilterDropdown/DateFilterDropdown";
import { DataTable } from "../../../Table/DataTable";
import {
  IDataTableProps,
  MobileLogoRenderType,
  RenderType,
} from "../../../Table/interfaces/IDataTableProps";
import { CSVExportPlugin, RefreshPlugin } from "../../../Table/plugins";

import moment from "moment";
import { api } from "../../../../api/api";
import { useDateFilter } from "../../../Table/hooks/useDateFilter";
import { useAuth } from "../../../../contexts/AuthProvider/AuthProvider";
import { useMessagesPopup } from "../../../../contexts/MessagesPopupProvider/MessagesPopupProvider";
import { IComplaintDetails } from "../../../../views/complaint/interface/IComplaint";
import { Dialog } from "../../../Dialogs/Dialog";
import { IComplaintHistory } from "./interface/IComplaintHistory";
import { IComplaint } from "../../../../constants/commonTypes";
import { AspectRatio } from "@mui/icons-material";
import { ContextMenu } from "../../../ContextMenu/ContextMenu";
import { PreviewComplaint } from "../../../../views/assignComplaint/components/PreviewComplaint/PreviewComplaint";
import { convertToIST } from "../../../../helpers";

export const ComplaintHistory: React.FC<IComplaintHistory> = (props) => {
  const { open, onClose, memberDetails } = props;
  const [tablePagination, setTablePagination] = React.useState({
    pageNumber: 1,
    rowsInPerPage: 5,
  });
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [openPreview, setOpenPreview] = React.useState<IComplaint | null>(null);

  const { showTopErrorSnackbar } = useMessagesPopup();
  const [Loading, setLoading] = React.useState(false);
  const [complaintDetails, setComplaintDetails] = React.useState<
    IComplaintDetails[]
  >([]);
  const {
    date,
    type,
    handleDateSelectChange,
    dateDropdownList,
    setDate,
    setType,
  } = useDateFilter();

  console.log(memberDetails);

  const auth = useAuth();
  const fetchMembershipDetails = async () => {
    if (auth.user.isLogin && auth.user.tokens && memberDetails) {
      try {
        setLoading(true);

        const res = await api.get(
          `open-and-closed-complaint-list?membership_code=${memberDetails}`,
          {
            headers: {
              "auth-Token": auth.user.tokens.access,
            },
          }
        );
        setComplaintDetails(res.data.result);
        setTotalRecords(res.data.total.totalDataLength);

        console.log(res);
      } catch (err) {
        showTopErrorSnackbar("Something went wrong!!");
      } finally {
        setLoading(false);
      }
    }
  };

  React.useEffect(() => {
    fetchMembershipDetails();
  }, [memberDetails, date, tablePagination, open]);


  // ===========table data====================
  const ComplaintDetails: IDataTableProps = {
    isPagination: true,
    isDataLoading: Loading,
    totalRecords: totalRecords,
    rowsPerPageOptions: tablePagination.rowsInPerPage,
    tableCommandBarProps: {
      leftItems: {
        customPlugins: [
          {
            key: "refresh",
            onRender: () => <RefreshPlugin onClick={fetchMembershipDetails} />,
          },
          //   {
          //     key: "csvExport",
          //     onRender: (columns, items) => (
          //       <CSVExportPlugin
          //         columns={columns}
          //         items={items}
          //         filePrefixName="Report"
          //       />
          //     ),
          //   },
        ],
      },
      rightItems: {
        plugins: {},
      },
    },
    mobileLogo: {
      type: MobileLogoRenderType.reactNode,
      onMobileLogoRender: (data: any) => {
        return (
          <Avatar
            sx={{
              width: 45,
              height: 45,
              color: "#fff",
              ml: "-8px",
              mr: 2,
            }}
          ></Avatar>
        );
      },
    },
    columns: [
      {
        key: "actions",
        headerName: "Actions",
        fieldName: "",
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row) => {
          const contextMenuOptions = [
            {
              icon: <AspectRatio />,
              label: "See Details",
              onClick: () => setOpenPreview(row),
            },
          ];

       

          return <ContextMenu menuOptions={contextMenuOptions} />;
        },
      },
      {
        key: "status",
        headerName: "Status",
        fieldName: "status",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "service_status",
        headerName: "Service Status",
        fieldName: "service_status",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "complaint_no",
        headerName: "Complaint No.",
        fieldName: "complaint_no",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "user_name",
        headerName: "Name",
        fieldName: "user_name",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },

      {
        key: "reg_contact_no",
        headerName: "Mobile Number",
        fieldName: "reg_contact_no",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "vehicle_number",
        headerName: "Vehicle Number",
        fieldName: "vehicle_number",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "vehicle_make",
        headerName: "Brand",
        fieldName: "vehicle_make",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "vehicle_model",
        headerName: "Model Name",
        fieldName: "vehicle_model",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },

      {
        key: "service_city",
        headerName: "Service City",
        fieldName: "service_city",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "created_dt",
        headerName: "Complaint Date & Time",
        fieldName: "created_dt",
        renderType: RenderType.DATE_TIME,
        exportCellWidth: 35,
        onRowCellRender: (value, row: IComplaint) => (
          <div>
            {/* Adding 5 hours and 30 minutes to complaint created time */}
            {convertToIST(row.created_dt)}
          </div>
        ),
      },
      {
        key: "fault_type",
        headerName: "Fault Type",
        fieldName: "fault_type",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "fault",
        headerName: "Fault ",
        fieldName: "fault",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
      {
        key: "sub_fault",
        headerName: "Sub Fault",
        fieldName: "sub_fault",
        renderType: RenderType.TEXT,
        exportCellWidth: 35,
      },
    ],
    items: complaintDetails.slice(
      (tablePagination.pageNumber - 1) * tablePagination.rowsInPerPage,
      tablePagination.pageNumber * tablePagination.rowsInPerPage
    ),
    onPageChange: (newPageNumber: number) => {
      setTablePagination({ ...tablePagination, pageNumber: newPageNumber });
    },
    onRowsPerPageChange: (pageNumber: number, rowsPerPage: number) => {
      setTablePagination({
        pageNumber: pageNumber,
        rowsInPerPage: rowsPerPage,
      });
    },
  };

  return (
    <Dialog
      open={open}
      title="Complaint History"
      onClose={onClose}
      size="lg"
      actions={[
        { type: "button", label: "Close", variant: "text", onClick: onClose },
      ]}
    >
      <StandadCard heading="Previous Complaint Details" sx={{ mt: 4 }}>
        <DataTable {...ComplaintDetails} />
      </StandadCard>

      {openPreview && (
        <PreviewComplaint
          open={true}
          complaint={openPreview}
          onClose={() => setOpenPreview(null)}
        />
      )}
    </Dialog>
  );
};
